import { useEffect, useState } from "react";
import { X } from "lucide-react";
import SocialMediaPreview from "./SocialMediaPreview";
import { MAX_RETRY_LIMIT } from "./SocialHubBoostEngagement";
import { Img } from "components";
import Lottie from 'lottie-react';
import RefreshAnimation from "assets/images/RefreshAnimation.json"

export default function SocialMediaPost({
  data,
  setIsModalOpen,
  handleRetry,
  onPostNowClick,
  selectedEvent,
}) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [hashtags, setHashtags] = useState([]);
  const [retryCount, setRetryCount] = useState(1);

  useEffect(() => {
    const savedCount = sessionStorage.getItem("socialMediaPostRetryCount");
    if (savedCount) setRetryCount(parseInt(savedCount, 10));
  }, []);

  useEffect(() => {
    if (data?.structured_data) {
      const structuredData = data.structured_data;
      const hashtagString = structuredData.hashtags;
      const trimmedString = hashtagString?.trim?.();
      const hashtagArray = trimmedString ? trimmedString.split(/\s+/) : [];

      setTitle(structuredData.title);
      setDescription(structuredData.description);
      setHashtags(hashtagArray);
    }
  }, [data]);

  const removeHashtag = (tag) => {
    setHashtags(hashtags.filter((t) => t !== tag));
  };

  const handleRetryClick = () => {
    if (retryCount >= MAX_RETRY_LIMIT) return;
    sessionStorage.setItem("socialMediaPostRetryCount", String(retryCount + 1));
    handleRetry();
  };

  return (
    <div className="bg-[#f3f2f3] flex gap-[3vh] rounded-xl p-[4vh] min-h-[70vh] w-[75vw] max-w-[1800px]">
      <div className="flex flex-col justify-between w-[68%] text-[2.2vh]">
        <div>
          <h1 className="text-[3vh] font-semibold mb-[2vh]">Social Media Post</h1>
          <div className="mb-[3vh]">
            <label className="block mb-[2vh]">Title</label>
            <input
              type="text"
              name="title"
              className="w-full border border-[#adafb3] p-[1.5vh] rounded"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              style={{
                border: "1px solid #adafb3",
                padding: "0.5rem",
              }}
            />
          </div>

          <div className="mb-[3vh]">
            <label className="block mb-[2vh]">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full border border-[#adafb3] p-[1.5vh] h-[15vh] resize-none focus:border focus:border-[#adafb3]"
            />
          </div>

          <div className="mb-[3vh]">
            <label className="block mb-[2vh]">Hashtags</label>
            <div className="flex flex-wrap gap-[2vh]">
              {hashtags?.map((tag, index) => (
                <div
                  key={index}
                  className="inline-flex items-center rounded-full bg-[#e4e0f7]"
                >
                  <span className="p-[1.2vh] text-[2vh]">{tag}</span>
                  <button
                    onClick={() => removeHashtag(tag)}
                    className="flex items-center justify-center p-[1vh] ml-[0.8vh] bg-[white] drop-shadow-lg rounded-full focus:outline-none"
                  >
                    <X size={20} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 items-center mt-[4vh]">
          <span className="font-manropeB text-[2.6vh] text-[#787878]"><span className="text-smd_blue-normal">{retryCount}</span>/{MAX_RETRY_LIMIT}</span>
          <div className="flex justify-center">
            <button
              className="flex justify-center items-center gap-1 bg-[#61B15A] text-[white] font-light text-[2.4vh] rounded-xl py-1 px-4 w-fit"
              disabled={retryCount >= MAX_RETRY_LIMIT}
              onClick={handleRetryClick}
              style={{ opacity: retryCount >= MAX_RETRY_LIMIT ? 0.5 : 1 }}
            >
              <Lottie animationData={RefreshAnimation} className="text-smd_blue-normal h-[6vh]" />
              Regenerate
            </button>
          </div>
          <div></div>
        </div>
      </div>

      <div className="w-[1px] bg-[#CCCCCC] h-auto self-stretch"></div>

      <div className="w-[30%] min-w-[320px] text-[2.2vh]">
        <div className="flex items-center justify-between">
          <h1 className="text-[3vh] font-semibold">Preview</h1>
          <button
            onClick={() => {
              setIsModalOpen(false);
            }}
            className="p-[0.8vh]"
          >
            <Img src="/images/Close.svg" alt="close" className="h-[3vh]" />
          </button>
        </div>
        <div>
          <SocialMediaPreview selectedEvent={selectedEvent} title={title} />
          <button
            className="w-full mt-[1.5vh] px-[3vh] py-[1.2vh] text-white rounded-md font-medium outline-none text-[#fff] bg-[#144582] hover:bg-[#0e305a]"
            onClick={onPostNowClick}
          >
            Publish Now
          </button>
        </div>
      </div>
    </div>
  );
}
